import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { AudioManager} from "../../AudioManager";
import { Rect } from "../.././MyHelpers";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FontResource } from "../../ResourceManager/FontResource";

//namespace SlotGames {

    export class SpiritOfThunder_2Screen extends SlotGameType1_2Screen {

        
        //protected panelFactory: IPanelFactory = new SpiritOfThunderPanelFactory();
        protected override helpFactory: IHelpFactory = new SpiritOfThunderHelpFactory();
        //LED COLOR
        protected override ColorLed: string = "137,0,0\n";


        //SEND COLOR 
        protected override color: RewardColor =
            {
                color: "white",
                coloroutherStroke: "black",
                colorinnerStroke: "red",
            }

        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "SpiritOfThunder");

            this.spinnableReelsParams.topBorderWidth = 10;
            this.spinnableReelsParams.bottomBorderWidth = 10;
        }
    }
    //Panel Colorized
    class SpiritOfThunderPanelFactory implements IPanelFactory {
        public CreateNewPanel(params: PanelParams): Panel {
            return new SpiritOfThunderPanel(params);
        }
    }

    class SpiritOfThunderPanel extends Panel {
        protected override ButtonBackground(): ButtonColors {
            let color: ButtonColors = {
                backgroundButtonColor: "linear-gradient(rgb(38, 1, 1),rgb(89, 3, 3), rgb(140, 4, 4),rgb(89, 3, 3),rgb(38, 1, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
                linearColor: "linear-gradient(to left , transparent, DarkOrange,transparent ) 0 10 100%",
            };

            return color;
        }
    }


    //Help Colorized
    class SpiritOfThunderHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new SpiritOfThunderHelp(params);
        }
    }

    class SpiritOfThunderHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(38, 1, 1),rgb(89, 3, 3), rgb(140, 4, 4),rgb(89, 3, 3),rgb(38, 1, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }

//}